<template>
  <div class="modal-produto-item">
    <!-- {{ produtoSelecionado }} -->
    <h3>PRODUTO</h3>
    <CenarioInput
      :disabled="false"
      placeholder="Selecione um produto para monitorar"
      :model="produto"
      :options="produtoOptions.map(p => p.label)"
      @update:model="update => (produto = update)"
      @selected="update => (produtoSelecionado = produtoOptions.find(f => f.label == update))"
    />
    <BotaoPadrao
      arredondadoDireita
      class="adicionar-button"
      nome="Adicionar novo produto"
      icone="plus"
      :click="transformaAdicionar"
      cor="azul"
      tooltip="Clique para adicionar um produto que não esteja na lista acima"
    />
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "InputAdicionarProduto",
  components: {
    CenarioInput,
    BotaoPadrao
  },
  props: {
    produtosCadastrados: Array,
    atualizaModal: Boolean
  },
  data() {
    return {
      produto: "",
      produtoSelecionado: ""
    };
  },
  watch: {
    produtoSelecionado() {
      this.$emit("selecionaProduto", this.produtoSelecionado);
    },
    atualizaModal() {
      this.produto = "";
      this.produtoSelecionado = "";
    }
  },
  computed: {
    produtoOptions() {
      let options = [];
      this.produtosCadastrados.forEach((e, i) => {
        let label = `NCM: ${e.ncm} - ${e.ex != "0" ? "Ex: " + e.ex + " - " : ""}${
          e.cest != "0" ? "Cest: " + e.cest + " - " : ""
        } Nome: ${e.nome.length > 40 ? e.nome.slice(0, 40) + "..." : e.nome}`;
        options.push({ label: label, ...this.produtosCadastrados[i] });
      });
      return options;
    }
  },
  methods: {
    transformaAdicionar() {
      this.$emit("adicionar");
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}

.modal-produto-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--cinza03);
}
.adicionar-button {
  margin-top: 15px;
}
</style>
